function initialiseAnnouncements() {
 document.querySelectorAll('[data-ceylonae-announcement]').forEach(bar=>{
  if(bar.dataset.bound)return;
  bar.dataset.bound='true';
  const duration=Math.max(0,Number(bar.dataset.minutes)||0)*60;
  const period=duration*1000;
  const storageKey='ceylonae:announcement:deadline:v1:'+duration;
  let end=0;
  try{end=Number(localStorage.getItem(storageKey));}catch{}
  const save=()=>{try{localStorage.setItem(storageKey,String(end));}catch{}};
  if(!Number.isFinite(end)||end<=0||end>Date.now()+period){end=Date.now()+period;save();}
  const fields=['hours','minutes','seconds'].map(key=>bar.querySelector('[data-'+key+']'));
  const update=()=>{
   const now=Date.now();
   if(period>0&&end<=now){end+=(Math.floor((now-end)/period)+1)*period;save();}
   const remaining=period>0?Math.max(0,Math.ceil((end-now)/1000)):0;
   [Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].forEach((value,i)=>fields[i].textContent=String(value).padStart(2,'0'));
   return remaining;
  };
  update();
  const interval=setInterval(()=>{if(!bar.isConnected){clearInterval(interval);return;}update();},1000);
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseAnnouncements);else initialiseAnnouncements();
document.addEventListener('shopify:section:load',initialiseAnnouncements);
